const PROGRESS_KEY = "gto-scene-progress-v2";

export type ProgressAttempt = { choice: string; correct: boolean; at: number };
export type ProgressEntry = {
  first: ProgressAttempt;
  last: ProgressAttempt;
  attempts: number;
};
export type ProgressStore = { answered: Record<string, ProgressEntry> };

export function loadProgress(): ProgressStore {
  try {
    const raw = localStorage.getItem(PROGRESS_KEY);
    if (!raw) return { answered: {} };
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const answered: Record<string, ProgressEntry> = {};
    for (const [k, v] of Object.entries(parsed.answered ?? parsed)) {
      const val = v as Record<string, unknown>;
      if (val && typeof val === "object" && "first" in val) {
        answered[k] = val as unknown as ProgressEntry;
      } else if (val && typeof val === "object" && "choice" in val) {
        const legacy = val as unknown as ProgressAttempt;
        answered[k] = { first: legacy, last: legacy, attempts: 1 };
      }
    }
    return { answered };
  } catch {
    return { answered: {} };
  }
}

export function saveAnswer(sceneKey: string, choice: string, correct: boolean): void {
  const p = loadProgress();
  const now = Date.now();
  const attempt: ProgressAttempt = { choice, correct, at: now };
  const existing = p.answered[sceneKey];
  if (existing) {
    existing.last = attempt;
    existing.attempts += 1;
  } else {
    p.answered[sceneKey] = { first: attempt, last: attempt, attempts: 1 };
  }
  try {
    localStorage.setItem(PROGRESS_KEY, JSON.stringify(p));
  } catch { /* private mode / quota */ }
}

// ─── useSyncExternalStore 适配(缓存快照,引用稳定;供 stats 等页 hydration 安全读取) ──

let progressCache: ProgressStore = { answered: {} };
let progressRaw: string | null = null;

export function getProgressSnapshot(): ProgressStore {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(PROGRESS_KEY);
  } catch {
    raw = null;
  }
  if (raw !== progressRaw) {
    progressRaw = raw;
    progressCache = loadProgress();
  }
  return progressCache;
}

export function subscribeProgress(onChange: () => void): () => void {
  window.addEventListener("storage", onChange);
  return () => window.removeEventListener("storage", onChange);
}
